import React from 'react';
import PropTypes from 'prop-types';
import { 
  Table, 
  TableBody, 
  TableCell, 
  TableContainer, 
  TableHead, 
  TableRow 
} from '@mui/material';


const EnergyUsage = ({data}) => {

  const {
    reportedDcKwh,
    reportedAcKwh,
  } = data;

  const totalKwh = reportedDcKwh + reportedAcKwh;

  return (
    <div className="mb-6">
      <h3 className="text-[16px] font-semibold mb-2">Energy Usage</h3>
      <TableContainer>
        <Table 
          aria-label="Energy Usage" 
          sx={{
            borderCollapse: 'separate',
            borderRadius: '15px',
            border: '1px solid rgb(224, 224, 224)',
          }}>
          <TableHead>
            <TableRow>
              <TableCell sx={{fontWeight: 'bold'}}>Type</TableCell>
              <TableCell align="right" sx={{fontWeight: 'bold'}}>kWh</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            <TableRow>
              <TableCell>DC Electricity Used</TableCell>
              <TableCell align="right">{`${reportedDcKwh} kWh`}</TableCell>
            </TableRow>
            <TableRow>
              <TableCell>AC Electricity Used</TableCell>
              <TableCell align="right">{`${reportedAcKwh} kWh`}</TableCell>
            </TableRow>
            <TableRow>
              <TableCell sx={{fontWeight: 'bold'}}>Total</TableCell>
              <TableCell align="right" sx={{fontWeight: 'bold'}}>{`${totalKwh} kWh`}</TableCell>
            </TableRow>
          </TableBody>
        </Table>
      </TableContainer>
    </div>
  );
}


export default EnergyUsage;

EnergyUsage.propTypes = {
  data: PropTypes.object.isRequired,
};